export default __webpack_public_path__ + "media/images/fonts/fontawesome-webfont-a35720c2fed2c7f043bc7e4ffb45e073.woff";